import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import DatePicker from 'react-datepicker';
import DataWrapper from "../../../principal/containers/DataWrapper";
import { Validacao } from "../../../comum/components/Validacao";
import _ from 'lodash';
import ParametrosGeraisStore from "../../../administracao/stores/ParametrosGeraisStore";
import { Redirect } from "react-router-dom";
import { FormWithActions } from "../../../comum/components/FormWithActions";
import { LoadingPanel } from "../../../comum/components/LoadingPanel";
import FluxoMigracaoStore from "../stores/FluxoMigracaoStore";
import moment from "moment/moment";
import { formatarDataISO8601, formatarNomeProduto } from "../../../../utils/formatar";
import loading from '../../../../assets/images/ajax-loader.gif';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { DebitoForm } from "../../../solicitacao/components/DebitoForm";
import { DetalhamentoJustificativa } from "../../comum/components/DetalhamentoJustificativa";
import { DetalhamentoMigracoesAnteriores } from "../../comum/components/DetalhamentoMigracoesAnteriores";

@inject("store")
@DataWrapper
@observer
export class SolicitacaoMigracao extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.formStore = this.props.store.formStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;
        this.appStore = this.props.store.appStore;

        this.parametrosGeraisStore = new ParametrosGeraisStore();

        this.controller = new FluxoMigracaoStore(this.parametrosGeraisStore, this.loginStore, this.tituloPaginaStore, this.validacaoStore, this.modalStore, this.loadingPanelStore);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Migrar alocação para custeio");

        const taskId = _.get(this.props, "match.params.taskIdBpm");
        const solicitacaoId = _.get(this.props, "match.params.solicitacaoId");
        const solicitacaoEttId = _.get(this.props, "match.params.solicitacaoEttId");
        this.controller.carregarLista(taskId ? { id: taskId, tipo: "tarefa" } : {
            solicitacaoId: solicitacaoId,
            solicitacaoEttId: solicitacaoEttId,
            tipo: "solicitacao"
        }, false);
        this.parametrosGeraisStore.carregarLista();
        this.controller.carregarDados(solicitacaoEttId)
    }

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object,
        ])
    };

    render() {
        if (this.formStore.acaoEnviada) {
            return <Redirect to="/contratacoes-vigentes" />;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {

        const datas = this.controller.solicitacao.momentDataTermino ? this.controller.datasDisponiveis : null;
        
        const momentDataInicio = datas ? datas.dataInicioVigencia : null;
        const momentDataFim = datas ? datas.dataFim : null;
        const momentDatasRestritas = datas ? datas.datasRestritas : null;
        
        const mensagemTrocaSistemaAlocacao = this.controller.mensagemTrocaSistemaAlocacao;
        const mensagemAlocacaoMaiorQueData = this.controller.mensagemAlocacaoMaiorQueData;

        const isDateDisabled = (date) => {
            return momentDatasRestritas.some(
                (excluidas) => moment(date).isSame(excluidas, 'day')
            );
        }

        const options_table = {
            noDataText: this.controller.loading ? <img src={loading} alt="loading" className="loading" /> : "Não há registros.",
        };

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller} taskId={_.get(this.props, "match.params.taskIdBpm")} solicitacaoExcecao={this.controller.isSolicitacaoExcecao}
                                    tarefa={this.controller.nomeTarefa} fluxo={this.controller.nomeFluxo} possiveisAcoes={this.controller.isDadosAlterados ? ["MIGRAR"] : [""]}
                                    error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>

                                    <BootstrapTable options={options_table} data={this.controller.dados}>
                                        <TableHeaderColumn columnTitle width='100' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} isKey dataField='nome'>Nome</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='100' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataField='cpf'>CPF</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='100' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataField='cargo'>Cargo</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='75' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={formatarDataISO8601} dataField='dataInicio'>Data início</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='75' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={formatarDataISO8601} dataField='dataFim'>Data fim</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='100' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataField='empresa'>Unidade de negócio (BU)</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='100' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataField='arDebito'>Centro de custo débito</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='125' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataField='trabalhoExterno'>Previsão trabalho externo</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='100' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataField='localTrabalho'>Local de trabalho</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='100' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataField='justificativa'>Justificativa</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='100' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={formatarNomeProduto} dataField='produto'>Projeto/centro de resultado/finalidade</TableHeaderColumn>
                                        <TableHeaderColumn columnTitle width='150' tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataField='detalhamento'>Detalhamento da justificativa/alocação</TableHeaderColumn>
                                    </BootstrapTable>
                                    <DetalhamentoMigracoesAnteriores />
                                    <DebitoForm />
                                    <DetalhamentoJustificativa isMigracaoAlocacao={true} />
                                    <h4>Nova alocação</h4>
                                    <Row>
                                        <Col xs={12} md={6} lg={4}>
                                            <FormGroup>
                                                <Label for="data">Início no novo projeto/centro de resultado/finalidade <sup>*</sup></Label>
                                                <DatePicker
                                                    ref="dataInicio"
                                                    onClickOutside={() => { this.refs.dataInicio.cancelFocusInput(); this.refs.dataInicio.setOpen(false); }}
                                                    clocale={"pt_BR"}
                                                    className="form-control"
                                                    dateFormat="DD/MM/YYYY"
                                                    selectsStart
                                                    disabled={!this.controller.isDadosAlterados}
                                                    minDate={momentDataInicio}
                                                    maxDate={momentDataFim}
                                                    filterDate={(date) => !isDateDisabled(date)}
                                                    selected={this.controller.momentData}
                                                    onChange={(value) => this.controller.setData(value)}
                                                    onChangeRaw={(e) => this.controller.setDataAlocacaoCheck(e.target.value)}
                                                />
                                                <Validacao id="data"
                                                    valor={this.controller.dataValidacao}
                                                    tipo={[
                                                        "isDate", "isRequired",
                                                        "compararDataAnterior", momentDataInicio,
                                                        "compararDataPosterior", momentDataFim,
                                                        "compararDatasRestritas", momentDatasRestritas]} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {mensagemTrocaSistemaAlocacao !== "" && this.controller.isDadosAlterados &&
                                        <span style={{ color: 'darkorange', display: 'block' }}>{mensagemTrocaSistemaAlocacao}</span>
                                    }
                                    {mensagemAlocacaoMaiorQueData !== "" &&
                                        <span style={{ color: 'darkorange', display: 'block' }}>{mensagemAlocacaoMaiorQueData}</span>
                                    }
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}